export const InactivityErrorMessage = 'You have been logged out due to inactivity.';